// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course-snap-contrast-wrapper[data-v-b5f1b8e4]{display:flex}.course-snap-contrast-wrapper .course-snap-contrast-item[data-v-b5f1b8e4]{flex:1}.course-snap-contrast-wrapper .course-snap-contrast-item img[data-v-b5f1b8e4]{width:100%}", ""]);
// Exports
module.exports = exports;
